import { Component, OnInit } from '@angular/core';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  canCreateTemplates = false;
  asperaClientMode = 'connect';

  constructor(private usersService: UsersService) { }

  ngOnInit() {
    this.usersService.profile.subscribe((profile) => {
      this.canCreateTemplates = profile.canCreateTemplates;
      this.asperaClientMode = profile.asperaClientMode || 'connect';
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/settings.component.ts